enum NotificationStateEnum {
  Unread = 'Unread',
  Read = 'Read',
}

export default NotificationStateEnum;
